import { PerformanceDashboard } from '@futrli-sdk/performance_dashboards';

import { ApiView, ApiViewState, getDefaultApiViewState } from '../../../core/ApiView';
import { performanceDashboardsQuery } from '../../../queries/performanceDashboards';

export interface PerformanceDashboardsViewState extends ApiViewState {
  performanceDashboards: PerformanceDashboard[];
}

export class PerformanceDashboardsView extends ApiView {
  private performanceDashboardsObs: ReturnType<typeof performanceDashboardsQuery>;

  public state: PerformanceDashboardsViewState = {
    ...getDefaultApiViewState(),
    performanceDashboards: []
  };

  constructor(workspaceId: string, organisationId: string) {
    super();

    this.performanceDashboardsObs = this.addQuery(performanceDashboardsQuery(workspaceId, organisationId));

    this.updateState();
  }

  // ****************************
  // * Private / Protected API *
  // ****************************
  protected getNewState(): PerformanceDashboardsViewState {
    return {
      ...super.getNewState(),
      performanceDashboards: this.getResult(this.performanceDashboardsObs).data ?? []
    };
  }
}
